import { Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from '@store/useAuthStore'; // Import the store directly
import { useSessionValidator } from '@/hooks/useSessionValidator'; // ✅ 1. Importamos nuestro nuevo hook
import { CONFIG } from '@utils/constants';

// Vistas y Componentes
import Login from '@pages/Login';
import Dashboard from '@pages/Dashboard';
import GameView from '@pages/GameView';
import LobbyView from '@pages/LobbyView';
import NotFound from '@pages/NotFound';
import feedback, { FeedbackPanel } from '@components/ui/general/feedback';
import DebugInitializer from './components/developer/utils/DebugInitializer';

function App() {

  const isValidating = useSessionValidator();
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = !!user; // Derivamos el estado aquí.

  //console.log("[App] User:", user, "Authenticated:", isAuthenticated, "Validating:", isValidating);
  if (isValidating) {
    return <div>Validating session...</div>;
  }

  return (
    <>
      {CONFIG.DEBUG_MODE && <DebugInitializer />}
      <Routes>
        {/* ✅ 3. Usamos la variable isAuthenticated que ya calculamos */}
        <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />} />
        <Route path="/lobby/:gameId" element={isAuthenticated ? <LobbyView /> : <Navigate to="/" />} />
        <Route path="/games/:gameId" element={isAuthenticated ? <GameView /> : <Navigate to="/" />} />
        <Route path="*" element={<NotFound user={user} />} />
      </Routes>
      <FeedbackPanel />
    </>
  );
}

export default App;